import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, Phone, AlertTriangle } from "lucide-react";

export default function PanicScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    window.history.replaceState(null, "", "/panic");
  }, []);

  const emergencyNumbers = [
    { number: "112", label: "Urgences Européen", bgColor: "bg-red-50 dark:bg-red-950/20", textColor: "text-red-600 dark:text-red-400" },
    { number: "15", label: "SAMU", bgColor: "bg-red-50 dark:bg-red-950/20", textColor: "text-red-600 dark:text-red-400" },
    { number: "3114", label: "Numéro national de prévention du suicide", bgColor: "bg-red-50 dark:bg-red-950/20", textColor: "text-red-600 dark:text-red-400" },
    { number: "0 800 23 13 13", label: "Drogues Info Service (24h/24)", bgColor: "bg-primary/10", textColor: "text-primary" },
    { number: "0800 23 52 36", label: "Centre Antipoison", bgColor: "bg-secondary", textColor: "text-foreground" },
    { number: "09 72 39 40 50", label: "SOS Amitié (24h/24)", bgColor: "bg-secondary", textColor: "text-foreground" },
    { number: "09 80 98 09 30", label: "Écoute Sexualités (8h-23h)", bgColor: "bg-purple-50 dark:bg-purple-950/20", textColor: "text-purple-600 dark:text-purple-400" },
  ];

  const handleCall = (number: string) => {
    const cleanNumber = number.replace(/\s/g, "");
    window.location.href = `tel:${cleanNumber}`;
  };

  return (
    <div className="min-h-dvh bg-background flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full">
        <CardHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-destructive/10 rounded-lg">
              <ShieldAlert className="h-6 w-6 text-destructive" />
            </div>
            <CardTitle className="text-2xl">Numéros d'urgence</CardTitle>
          </div>
          <CardDescription>En cas de danger immédiat, utilise ces numéros.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-3">
            {emergencyNumbers.map((emergency, index) => (
              <div key={index} className={`flex items-center justify-between p-4 rounded-lg ${emergency.bgColor}`}>
                <div className="flex-1">
                  <p className={`text-2xl font-bold ${emergency.textColor}`}>{emergency.number}</p>
                  <p className="text-sm text-muted-foreground">{emergency.label}</p>
                </div>
                <Button variant="outline" size="default" onClick={() => handleCall(emergency.number)} className="ml-4">
                  <Phone className="h-4 w-4 mr-2" />Appeler
                </Button>
              </div>
            ))}
          </div>

          <div className="flex items-start gap-3 p-4 bg-warning/10 rounded-lg border border-warning/20">
            <AlertTriangle className="h-5 w-5 text-warning flex-shrink-0 mt-0.5" />
            <p className="text-sm text-muted-foreground">
              Ces numéros sont à utiliser en cas d'urgence réelle. Pour un accompagnement ou des questions, consulte nos ressources ou parle à un·e proche de confiance.
            </p>
          </div>

          <div className="pt-4 border-t">
            <Button variant="ghost" size="sm" onClick={() => navigate("/")} className="w-full">
              Retour à l'accueil
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
